import React, {useContext, useEffect, useState} from 'react'
import {SessionContext} from 'Utils/sessions';
import s from './styles/Dashboard.module.scss'
import SideBar from 'Components/Nav/SideBar';
import {setSessionCookie} from "../Utils/sessions";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import {AdminApi} from "../Api/AdminApi";

const PaymentsDashboard = () => {
    const {session} =  useContext(SessionContext);
    const [paymentsPageData, setPaymentsPageData] = useState(null);
    const userTableHeader = ['ID', 'First Name', 'Last Name', 'Email', 'Student Type', 'School', 'Verified']
    const [resetFilter, setResetFilter] = useState(false)
    const [filerOpen, setFilterOpen] = useState(false)
    const [topic, setTopic] = useState('')

    useEffect(() => {
        if (resetFilter) {
            setTopic('')
        }
    }, [resetFilter])

    function toggleFilter() {
        setFilterOpen(!filerOpen)
    }

    function updateTopic(e) {
        setTopic(e?.target?.value.replaceAll(' ', '-'))
        setFilterOpen(false)
    }

    useEffect(() => {
        // AdminApi.User.getAdminPagePaymentsData({}, session.jwt).then(res => {
        //     setPaymentsPageData(res.data);
        // }).catch(error => {
        //     if (error.message?.includes( '404')) {
        //         setSessionCookie({})
        //         window.location.href = window.location.hostname
        //     }
        // })
    }, [session.jwt])

    return <div>
        <SideBar session={session} title={"Manage Payments"}>
            <div className={s.adminDashboard}>
                <main className={s.dataSection}>
                    <h3 className='heading'>Payments</h3>
                    <div className={s.dataTableContainer}>

                    </div>
                </main>
                <aside className={s.filterSection}>
                    <Card className={s.filterCard}>
                        <Card.Title className={s.filterCardHeader}>
                            <div className={s.filterCardTitle}>Payments</div>
                        </Card.Title>
                        <Card.Body>
                        <div><strong>Total:</strong> {paymentsPageData?.users?.length ?? 0}</div>
                            <div><strong>Colleges Represented:</strong> {paymentsPageData?.registeredColleges?.length ?? 0}</div>
                            <div><strong>Colleges With Mentors:</strong> {paymentsPageData?.registeredColleges?.length ?? 0}</div>
                        </Card.Body>
                    </Card>
                    <Card className={s.filterCard}>
                        <Card.Title className={s.filterCardHeader}>
                            <div className={s.filterCardTitle}>Filter Payments</div>
                            <div className={s.filterCardFilterToggle}>
                                <Button className={`btnLink`}
                                        onClick={toggleFilter}>{filerOpen ? 'Close' : 'Edit'}</Button>
                            </div>
                        </Card.Title>
                        <div className={s.mobile}>
                            {filerOpen &&
                                <>
                                    <Card.Body className={'my-0'}>
                                        <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                                onClick={updateTopic} value={''}>All topics</Button>
                                        {[].map((blogTopic, idx) =>
                                            <Button key={idx}
                                                    className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                                    onClick={updateTopic}
                                                    value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                        )}
                                    </Card.Body>
                                </>
                            }
                        </div>
                        <div className={s.desktop}>
                            <Card.Body className={'my-1'}>
                                <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                        onClick={updateTopic} value={''}>All topics</Button>
                                {[].map((blogTopic, idx) =>
                                    <Button key={idx}
                                            className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                            onClick={updateTopic}
                                            value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                )}
                            </Card.Body>
                        </div>
                    </Card>
                </aside>
            </div>
        </SideBar>
    </div>
}

export default (PaymentsDashboard);
